import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { attendanceAPI } from '../services/api';

const EmployeeProfile = () => {
  const { user, logout } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setErr('');
        const res = await attendanceAPI.employeeProfile();
        setData(res.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || 'No se pudo cargar tu perfil');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const name = data?.name || user?.name;
  const email = data?.email || user?.email;
  const initial = (name || '?').charAt(0).toUpperCase();

  return (
    <div className="space-y-4">
      {loading && <p className="text-sm text-slate-500">Cargando…</p>}
      {err && <p className="text-sm text-red-600">{err}</p>}

      {!loading && !err && (
        <>
          <div className="card-mobile space-y-3">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-blue-600 text-lg font-bold text-white shadow-sm">
                {initial}
              </div>
              <h3 className="text-sm font-semibold text-slate-700">Datos personales</h3>
            </div>
            <div>
              <p className="form-label-mobile">Nombre</p>
              <p className="text-base font-medium text-gray-900">{name}</p>
            </div>
            <div>
              <p className="form-label-mobile">Email</p>
              <p className="text-gray-800 break-all">{email}</p>
            </div>
          </div>

          {(data?.employments || []).map((em) => (
            <div key={em.company_employee_id} className="card-mobile space-y-3">
              <div>
                <h3 className="text-sm font-semibold text-slate-700">Empresa</h3>
                <p className="text-base font-medium text-gray-900">{em.company_name}</p>
                {!em.active && <p className="text-xs text-amber-700 mt-1">Registro inactivo en esta empresa</p>}
              </div>
              <div className="grid gap-2 sm:grid-cols-2">
                {em.employee_code && (
                  <div>
                    <p className="form-label-mobile">Código de empleado</p>
                    <p className="text-gray-800">{em.employee_code}</p>
                  </div>
                )}
                {em.job_title && (
                  <div>
                    <p className="form-label-mobile">Puesto</p>
                    <p className="text-gray-800">{em.job_title}</p>
                  </div>
                )}
                {em.hired_at && (
                  <div>
                    <p className="form-label-mobile">Alta</p>
                    <p className="text-gray-800">
                      {new Date(em.hired_at + 'T12:00:00').toLocaleDateString('es-AR', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })}
                    </p>
                  </div>
                )}
              </div>
              <div>
                <p className="form-label-mobile mb-2">Sedes asignadas</p>
                {em.factories.length === 0 ? (
                  <p className="text-sm text-slate-500">Sin sedes vinculadas aún.</p>
                ) : (
                  <ul className="space-y-2">
                    {em.factories.map((f) => (
                      <li
                        key={f.factory_id}
                        className="flex flex-col gap-0.5 rounded-lg border border-slate-200 bg-slate-50/80 px-3 py-2 text-sm"
                      >
                        <div className="flex items-center justify-between gap-2">
                          <span className="font-medium text-gray-900">{f.factory_name}</span>
                          {f.is_supervisor && (
                            <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase text-amber-900">
                              Supervisor
                            </span>
                          )}
                        </div>
                        <span className="text-xs text-slate-500 line-clamp-2">{f.address}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}

          {data && data.employments.length === 0 && (
            <div className="card-mobile">
              <p className="text-sm text-slate-600">
                Todavía no figuras en una empresa. Si acabas de darte de alta, pedí a tu empleador que te asigne a la
                empresa y a las sedes.
              </p>
            </div>
          )}

          <div className="px-0 pb-2">
            <button type="button" className="btn-mobile btn-danger w-full" onClick={logout}>
              Cerrar sesión
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EmployeeProfile;
